import { atom } from "jotai";
import { GraphQlAdapter } from "@/infrastructure/adapters/graphQl/GraphQl.adapter";
import { PromotionRepository } from "@/infrastructure/repositories/promotion/Promotion.repository";
import { GetPromoDeductionApplySummaryUseCase } from "@/core/usecases/promotion";
import { PromotionDeduction } from "@/core/entities/promotion/PromotionDeduction";
import {
  promotionAppliedDeductionsAtom,
  promotionAppliedDeductionsCurrentPageAtom,
  promotionAppliedDeductionsPageLimitAtom,
} from "./promotionAppliedDeductions.atoms";

const client = GraphQlAdapter.getInstance().getClient();
const promotionRepository = new PromotionRepository(client);

export const getPromoDeductionApplySummaryAtom = atom(
  null,
  async (
    get,
    set,
    {
      promoEventId,
      isLoading = false,
      isRefreshing = false,
    }: { promoEventId: number; isLoading?: boolean; isRefreshing?: boolean }
  ) => {
    set(promotionAppliedDeductionsAtom, prev => ({ ...prev, isLoading, isRefreshing, error: null }));
    try {
      const currentPage = get(promotionAppliedDeductionsCurrentPageAtom);
      const pageLimit = get(promotionAppliedDeductionsPageLimitAtom);

      const response = await new GetPromoDeductionApplySummaryUseCase(promotionRepository).execute(
        {
          promo_event_id: promoEventId,
          page_number: currentPage,
          page_size: pageLimit,
          sort_column: "applied_at",
          sort_order: "descend",
        },
        isRefreshing
      );

      set(promotionAppliedDeductionsAtom, prev => ({
        ...prev,
        items: response.data.map(row => PromotionDeduction.from(row)),
        totalDeductionsClaimed: response.totalDeductionsClaimed,
        totalDeductionsAmount: response.totalDeductionsAmount,
        count: response.count,
        hasFetched: true,
        currentPage,
        isLoading: false,
        isRefreshing: false,
        error: null,
      }));
    } catch (error) {
      set(promotionAppliedDeductionsAtom, prev => ({
        ...prev,
        isLoading: false,
        isRefreshing: false,
        error: error as Error,
      }));
    }
  }
);

export const setPromotionAppliedDeductionsCurrentPageAtom = atom(null, (get, set, page: number) => {
  set(promotionAppliedDeductionsAtom, {
    ...get(promotionAppliedDeductionsAtom),
    currentPage: page,
  });
});
